module.exports = __webpack_public_path__ + "static/media/screen-insta-MW.29fbd763.png";